<script setup>

import {checkDataElement} from "../../apps/base";
import {ref, computed} from "vue";

const emits = defineEmits(['suggestSelect']);
const model = defineModel();
const props = defineProps({
    type: {
        type: String,
        default: 'text'
    },
    name: {
        type: String,
        default: ''
    },
    suggestType: {
        type: String,
        default: ''
    },
    dataElement: String,
    label: String,
    size: String,
    disabled: Boolean,
    maxLength: Number,
    error: [String, Boolean],
});

const isFocused = ref(false);

const wrapClasses = computed(() => {
    let classes = [];

    if (props.error && !props.disabled) {
        classes.push('has-error');
    }

    if (isFocused.value) {
        classes.push('focus');
    }

    if (model.value !== null && model.value !== undefined) {
        if (('' + model.value) !== '') {
            classes.push('has-value');
        }
    }

    return classes
});
const inputClasses = computed(() => {
    let classes = [];

    if (props.size) {
        classes.push(props.size);
    }

    return classes
});
const labelClasses = computed(() => {
    let classes = [];

    if (props.size) {
        classes.push(props.size);
    }

    return classes
});
const inputType = computed(() => {
    if (props.type === 'file') {
        return 'file'
    }
    if (props.type === 'password') {
        return 'password'
    }
    return 'text'
});

const mask = computed(() => {
    if (props.type === 'phone') {
        return '+7(000)000-00-00'
    }
    return null
});

</script>

<template>
    <div class="form-group" :class="wrapClasses">
        <label
                class="plh"
                :data-element="checkDataElement('label-' + dataElement)"
                :class="labelClasses"
                v-if="label"
        >
            {{ label }}
        </label>
            <input
                    type="text"
                    :name="name"
                    :class="inputClasses"
                    v-model="model"
                    :disabled="disabled"
                    v-mask="mask"
                    v-suggest="suggestType"
                    @suggestSelect="emits('suggestSelect', $event.detail)"
                    @focus="isFocused = true"
                    @blur="isFocused = false"
                    :data-element="checkDataElement(dataElement)"
            />
    </div>
</template>

<script>

import {simpleMask} from "../../directives/SimpleMask";
import suggestDirective from "../../directives/Suggest";

export default {
    name: "FieldInput",
    directives: {
        mask: simpleMask,
        suggest: suggestDirective
    },
}
</script>